import React, { Component } from 'react'
import { APP_URL_API } from '../../setup/configs'
import SearchBox from '../common/SearchBox'
import axios from 'axios'

class SelectCommunity extends Component {
    constructor(props) {
        super(props)

        this.state = {
          searchString: '',
          communities: {}
        }

        this.onHandleChange = this.onHandleChange.bind(this);
        this.onHandleAdd = this.onHandleAdd.bind(this);

        this.CancelToken = axios.CancelToken;
        this.source = this.CancelToken.source();
    };
    onHandleChange(event) {
        this.setState({searchString: event.target.value});
    }
    onHandleAdd(community) {
        this.setState({
            searchString: ''
        }, this.props.onHandleAttachCommunity(community))
    }
    componentWillUnmount() {
        this.source.cancel('Fetching communities canceled by the user.');
    }
    componentDidMount() {
        const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'organizations/type/community';

        this.serverRequest =
            axios
                .get(url, {headers: config, cancelToken: this.source.token})
                .then(function(response) {
                        this.setState({
                            communities: response.data.data,
                            dataFetched: true
                        })
                }.bind(this))
                .catch(function(thrown) {
                    if(axios.isCancel(thrown)) {
                        // console.log('Request canceled', thrown.message);
                    } else {
                        // handle error
                    }
                })
    }
    render() {
        if(this.state.dataFetched) {
            return(
                <div>
                    <SearchBox placeholder="Søg og tilføj trossamfund" onChange={this.onHandleChange} value={this.state.searchString} />
                    <SearchResult searchString={this.state.searchString} onHandleAdd={this.onHandleAdd} communities={this.state.communities} />
                </div>
            )
        } else {
            return <div>Indlæser...</div>
        }
    }
}

class SearchResult extends Component {
    render() {
        const searchresult = [];
        this.props.communities.forEach(function(community, index) {
            if(this.props.searchString.length >= 3 && community.name.toLowerCase().indexOf(this.props.searchString.toLowerCase()) >= 0) {
                searchresult.push(<Option community={community} key={index} onHandleAdd={this.props.onHandleAdd} />);
            }
        }.bind(this));
        if(searchresult.length > 0) {
            return(
                <div>
                    <ul className="selectOrganization__list">{searchresult}</ul>
                </div>
            )
        } else {
            return null;
        }
    }
}

const Option = (props) => {
    return (
        <li className="selectOrganization__item" onClick={() => props.onHandleAdd(props.community)}>{props.community.name}</li>
    )
}

export default SelectCommunity;


// WEBPACK FOOTER //
// ./src/modules/community/SelectCommunity.js